import { SeprateThreeD, HandleCommaDeleted } from './seprateClass.js';
import { toEnglishNumbers } from './datePicker';

export const canTypeForNumInput = (e) => {
   const currentKey = toEnglishNumbers(e.key);

   e.ctrlKey && currentKey === 'a' && e.target.select();

   if (
      (currentKey >= '0' && currentKey <= '9') ||
      // e.code === "Space" ||
      currentKey === '.' ||
      currentKey === 'Control' ||
      currentKey === 'c' ||
      currentKey === 'Control' ||
      currentKey === 'v' ||
      currentKey === 'Backspace' ||
      currentKey === 'Delete' ||
      currentKey === 'Tab' ||
      currentKey === 'Enter' ||
      currentKey === 'ArrowUp' ||
      currentKey === 'ArrowDown' ||
      currentKey === 'ArrowRight' ||
      currentKey === 'ArrowLeft'
   ) {
      return true;
   }
   return e.preventDefault();
};

export const seperateNumber = (n) => {
   let number = (n + '').replaceAll(',', '').split('').reverse();
   let result = '';

   for (let i = 1; i <= number.length; i++) {
      if (i % 3 === 0) {
         number[i - 1] = ',' + number[i - 1];
      }
   }
   number.reverse().forEach((num) => (result += num));
   if (result.slice(0, 1) === ',') {
      result = result.slice(1);
   }
   return result;
};

// ##########################################################################
// ##########################################################################

let valueOfInput = '';
let numberOfCommaOnKeyDown, selectionStart, selectionEnd;

export let seprate = (e) => {
   let valueOfInputHelper, trueNm, numberOfCommaOnKeyUp;
   if (e.key === 'Backspace' || e.key === 'Delete') {
      if (selectionStart === selectionEnd) {
         let start = e.target.selectionEnd;
         trueNm = HandleCommaDeleted.deleteComma(e.target.value);
         e.target.value = SeprateThreeD.SeparatorOfThreeDigits(trueNm);
         valueOfInputHelper = trueNm;
         valueOfInputHelper
            .split('')
            .filter((el) => el !== ',')
            .join('');
         let ld = e.target.value.split('');
         numberOfCommaOnKeyUp = ld.reduce((a, c) => {
            if (c === ',') {
               a++;
            }
            return a;
         }, 0);
         if (numberOfCommaOnKeyDown !== numberOfCommaOnKeyUp) {
            e.target.selectionEnd = start - 1;
         } else {
            e.target.selectionEnd = start;
         }
      } else {
         let selection = e.target.selectionEnd;
         e.target.value = SeprateThreeD.SeparatorOfThreeDigits(e.target.value);
         e.target.selectionEnd = selection;
      }
   }

   if (e.key >= '0' && e.key <= '9') {
      valueOfInput = e.target.value;
      let start = e.target.selectionEnd;
      e.target.value = SeprateThreeD.SeparatorOfThreeDigits(valueOfInput);
      let ld = e.target.value.split('');
      let numberOfCommaOnKeyUp = ld.reduce((a, c) => {
         if (c === ',') {
            a++;
         }
         return a;
      }, 0);
      if (numberOfCommaOnKeyDown !== numberOfCommaOnKeyUp) {
         e.target.selectionEnd = start + 1;
      } else {
         e.target.selectionEnd = start;
      }
   }
   let contentValue = e.target.value
      .split('')
      .filter((el) => el !== ',')
      .join('');
};

export let seprateOne = (e) => {
   numberOfCommaOnKeyDown = e.target.value.split('').reduce((a, c) => {
      if (c === ',') {
         a++;
      }
      return a;
   }, 0);
   selectionStart = e.target.selectionStart;
   selectionEnd = e.target.selectionEnd;

   if (
      !(
         (e.key >= '0' && e.key <= '9') ||
         e.key === 'Backspace' ||
         e.key === 'Delete' ||
         e.key === 'ArrowRight' ||
         e.key === 'ArrowLeft'
      )
   ) {
      e.preventDefault();
   }
};
